import { useEffect, useState } from "react";
import { Reveal, Overline } from "./Reveal";
import { Star, Quote } from "lucide-react";
import { api } from "@/lib/api";

export const TestimonialsSection = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/testimonials").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  if (items.length === 0) return null;

  return (
    <section id="testimonials" className="relative py-24 md:py-32 bg-[#141414]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-2xl">
          <Overline>Client Success Stories</Overline>
          <h2 className="font-display font-semibold uppercase tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl mt-4 leading-tight">
            Real Clients. Real Results.
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((t, i) => (
            <Reveal key={t.id} delay={i * 0.06}>
              <div data-testid={`testimonial-${i}`} className="h-full bg-[#0A0A0A] border border-[#262626] flex flex-col">
                {(t.before_image || t.after_image) && (
                  <div className="grid grid-cols-2">
                    {[["Before", t.before_image], ["After", t.after_image]].map(([label, img]) =>
                      img ? (
                        <div key={label} className="relative aspect-[3/4] overflow-hidden border-b border-[#262626]">
                          <img src={img} alt={label} className="w-full h-full object-cover" />
                          <span className={`absolute top-2 left-2 text-[9px] uppercase tracking-widest font-bold px-2 py-1 ${label === "After" ? "bg-[#0055FF] text-white" : "bg-[#0A0A0A]/80 text-white border border-[#262626]"}`}>{label}</span>
                        </div>
                      ) : (
                        <div key={label} className="aspect-[3/4] bg-[#141414] border-b border-[#262626]" />
                      )
                    )}
                  </div>
                )}
                <div className="p-8 flex flex-col flex-1">
                  <Quote size={24} className="text-[#0055FF]" />
                  <div className="flex gap-1 mt-3">
                    {[...Array(5)].map((_, s) => (
                      <Star key={s} size={14} className={s < t.rating ? "fill-[#0055FF] text-[#0055FF]" : "text-[#262626]"} />
                    ))}
                  </div>
                  <p className="mt-4 text-[#A3A3A3] leading-relaxed flex-1">&ldquo;{t.review}&rdquo;</p>
                  <div className="mt-6 pt-4 border-t border-[#262626]">
                    <div className="font-display font-semibold text-white">{t.name}</div>
                    {t.result && <div className="text-xs uppercase tracking-widest text-[#0055FF] font-bold mt-1">{t.result}</div>}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
